import React, { memo } from "react";
import { CategoryIcon } from "./CategoryIcon";

type CategoryCardProps = {
  category: { key: string };
  onClick: (categoryKey: string) => void;
};

function CategoryCardComponent({ category, onClick }: CategoryCardProps) {
  return (
    <div
      className="flex flex-col"
      onClick={() => onClick(category.key)}
      role="button"
      tabIndex={0}
      aria-label={`View ${category.key} questions`}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(category.key);
        }
      }}
    >
      <div className="flex gap-3 text-[#064C68] bg-[#00000005] rounded-lg border border-[#0000001f] p-[10px] hover:bg-[#00000008] transition-colors cursor-pointer">
        <CategoryIcon category={category.key} />
        <div className="font-medium">{category.key}</div>
      </div>
    </div>
  );
}

export const CategoryCard = memo<CategoryCardProps>(CategoryCardComponent);
